
import { Component, Prop, Vue } from "vue-property-decorator";
import type {ImageMediaType} from '../../types/MediaTypes';

@Component({})
export default class GalleryImageComponent extends Vue {
    @Prop() readonly photo!: ImageMediaType

}
